import type { ReactElement } from 'react'
import { Progress } from './ui/progress.js'

interface Item {
  label: string
  state: 'pending' | 'active' | 'done'
}

interface Props {
  items: Item[]
  /** Optional 0..1 fill bar rendered below the checklist. */
  percent?: number | undefined
}

/**
 * Scan-progress checklist. shadcn `Progress` provides the bar; the rows above
 * are bespoke (steps with three states, not a percentage).
 */
export const ProgressBar = ({ items, percent }: Props): ReactElement => (
  <div className="rounded-2xl bg-foreground/85 text-background p-4 backdrop-blur-md shadow-lg">
    <ul className="space-y-2 text-sm">
      {items.map(item => (
        <li key={item.label} className="flex items-center gap-2.5">
          <span
            className={
              item.state === 'done'   ? 'inline-block w-2 h-2 rounded-full bg-[color:var(--color-ok-500)]' :
              item.state === 'active' ? 'inline-block w-2 h-2 rounded-full bg-[color:var(--color-warn-500)] animate-pulse' :
                                        'inline-block w-2 h-2 rounded-full bg-background/30'
            }
          />
          <span className={item.state === 'pending' ? 'text-background/50' : 'text-background'}>
            {item.label}
          </span>
        </li>
      ))}
    </ul>
    {percent != null && (
      <Progress value={percent * 100} className="mt-3 h-1 bg-background/20" />
    )}
  </div>
)
